import { Grid, Typography } from '@mui/material';
import classNames from 'classnames';
import { memo } from 'react';
import LangEnum from '../../../../../../../../../../../../lang/LangEnum';
import useTeceoStyles from '../../../../../../../../../../../../useTeceoStyles';
import { formatCompleteName } from '../../../../../../../../../../../../utils/formatters';
import { useApplicationContext } from '../../../../../../../../../../../context/ApplicationContext/ApplicationContext';
import { useTranslation } from '../../../../../../../../../../../translation/TranslationContext';
import { formatChatTime } from '../../../../../../../../../../utils/chat.formatters';
import { useChatMessageItemHeaderStyles } from './chatMessageItemHeader.styles';
import { ChatMessageItemHeaderProps } from './chatMessageItemHeader.types';

const ChatMessageItemHeader = ({ message, showMessageInfo }: ChatMessageItemHeaderProps) => {
  const translation = useTranslation();
  const { classes: teceoClasses } = useTeceoStyles();
  const { classes } = useChatMessageItemHeaderStyles();
  const { team } = useApplicationContext();

  const isMessageFromUser = message.user.id === team?.userId;

  return (
    <Grid
      container
      wrap="nowrap"
      spacing={1}
      direction={isMessageFromUser ? 'row-reverse' : 'row'}
      sx={{
        justifyContent: 'space-between',
      }}
    >
      <Grid>
        <Grid
          container
          wrap="nowrap"
          sx={{
            alignItems: 'center',
          }}
        >
          <Grid size="grow">
            {showMessageInfo && (
              <Grid container direction={isMessageFromUser ? 'row-reverse' : 'row'}>
                <Grid size={12}>
                  <Grid
                    container
                    wrap="nowrap"
                    spacing={1}
                    direction={isMessageFromUser ? 'row-reverse' : 'row'}
                    sx={{
                      alignItems: 'center',
                    }}
                  >
                    <Grid>
                      <Typography
                        color="textPrimary"
                        className={classNames(classes.nameTypography, teceoClasses.truncate)}
                      >
                        {isMessageFromUser
                          ? translation.translate(LangEnum.GLOBAL_YOU)
                          : formatCompleteName(
                              message.user.name,
                              message.user.surname,
                              message.user.email,
                            )}
                      </Typography>
                    </Grid>
                    <Grid>
                      <Typography
                        noWrap
                        color="textPrimary"
                        className={classNames(teceoClasses.secondaryTypography, classes.time)}
                      >
                        {formatChatTime(message.createdAt, translation.locale)}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>

                {!isMessageFromUser && (
                  <Grid>
                    <Typography
                      className={classNames(classes.typography, teceoClasses.truncate)}
                      variant="body2"
                      color="textSecondary"
                    >
                      {message.commercialName}
                    </Typography>
                  </Grid>
                )}
              </Grid>
            )}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default memo(ChatMessageItemHeader);
